import { ProgramProgressionStatus } from "@modules/programs/types/programOnOffTypes"
import { z } from "zod"

export const OnOffProgramProgressionDtoSchema = z
  .object({
    programId: z.string(),
    userId: z.string(),
    currentIndex: z.number(),
    duration: z.number(),
    startedAt: z.string().nullable(),
    stoppedAt: z.string().nullable(),
    status: z.enum(ProgramProgressionStatus),
  })
  .meta({ id: "OnOffProgramProgressionDtoSchema" })

export type OnOffProgramProgressionDto = z.infer<typeof OnOffProgramProgressionDtoSchema>
